export default "__VITE_ASSET__Ce$6HMPo__"